// @Utility
import { setStorage, getStorage } from "@utility/app/storage";

// Services
import { apiServices } from "@core/services/appService";

// Redux
const LOAD_SETTING = 'app/LOAD_SETTING';

/**
 * loadSetting (no-offline)
 * - signature: (myJson, setDataSettingError)
 * - ใช้ async/await
 * - Fallback cache เมื่อ API ล้มเหลว
 */
function loadSetting(dataJson, setDataSettingError) {
    return async (dispatch) => {
        const useCache = () => {
            const raw = getStorage("setting");
            if (!raw) return null;
            try {
                return JSON.parse(raw);
            } catch {
                return null;
            }
        };

        try {
            const agentCode = process.env.REACT_APP_DEFAULT_AGENT_CODE;
            if (!agentCode) {
                const cached = useCache();
                if (cached) {
                    dispatch({ type: LOAD_SETTING, payload: { items: cached } });
                    setDataSettingError?.(false);
                } else {
                    setDataSettingError?.(true);
                    dispatch({ type: LOAD_SETTING, payload: { items: null } });
                }
                return;
            }

            const { code: statusCode, result } = await apiServices('timeout', 'get', `/general/setting-cache/${agentCode}`)


            if ((statusCode === 200 || statusCode === 0) && result) {
                setDataSettingError?.(false);
                setStorage("setting", JSON.stringify(result));
                setStorage("agent_contact", JSON.stringify(result.agent_contact));
                setStorage("agent_logo", JSON.stringify(result.agent?.agent_image));
                dispatch({ type: LOAD_SETTING, payload: { items: result } });
                return;
            }

            // API ไม่สำเร็จ -> ใช้ cache
            const cached = useCache();
            if (cached) {
                dispatch({ type: LOAD_SETTING, payload: { items: cached } });
                setDataSettingError?.(false);
            } else {
                setDataSettingError?.(true);
                dispatch({ type: LOAD_SETTING, payload: { items: null } });
            }
        } catch (err) {
            // Exception -> ใช้ cache
            const cached = useCache();
            if (cached) {
                dispatch({ type: LOAD_SETTING, payload: { items: cached } });
                setDataSettingError?.(false);
            } else {
                setDataSettingError?.(true);
                dispatch({ type: LOAD_SETTING, payload: { items: null } });
            }
        }
    };
}

export {
    LOAD_SETTING,
    loadSetting
};
